"use strict";

import "./utility/analytics-controller";
import { getBasketData } from "../components/ticketing/basket-v2/api/getBasketData";
import { attribute, queryFirstDocument, trackEcommerceEvent } from "../utils";
import { attributes } from "./constants";
import "./autoCompleteAddress.js";
import { autoTabFields } from "./utility/autoTabFields";
import { generateQrCode } from "../utils/qrCodeGenerator";
import initTooltips from "../components/tooltip/tooltip";
import { togglePasswordVisibility } from "../components/form-components/inputPassword/inputPassword";

window.addEventListener("load", async () => {

    const basketButton = queryFirstDocument<HTMLAnchorElement>('.simplified-header__basket');
    const { data } = await getBasketData();
    togglePasswordVisibility();
    autoTabFields('[data-auto-tab-fields]');
    generateQrCode("[data-qr-code]");
    initTooltips();

    if (data && data.basketUrl) {
        basketButton.setAttribute("href", data.basketUrl);
        basketButton.classList.remove('u-v-hidden');
    }

    var confirmationPage = queryFirstDocument<HTMLElement>('.checkout--confirmation');

    if (confirmationPage) {
        var trackingData = JSON.parse(attribute(confirmationPage, attributes.orderTracking));

        trackEcommerceEvent({
            event: 'purchase',
            ecommerce: trackingData
        })
    }
});